import { render } from "./errorComponent.vue?vue&type=template&id=099e1365"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/errorComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "099e1365"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('099e1365', __exports__)) {
    api.reload('099e1365', __exports__)
  }
  
  module.hot.accept("./errorComponent.vue?vue&type=template&id=099e1365", () => {
    api.rerender('099e1365', render)
  })

}


export default __exports__